import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDtName, FormItemDtUserCode} from '../DT/FormChooseDt.jsx'

export default function FormChooseDt(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemDtUserCode />
            <FormItemDtName />
        </FormChooseExternal>
    )
}
